/*
    Essa função coloca os dados de uma entidade no grid da página
    Além disso, ela calcula quantos registros mostrar de acordo com
    os critérios de paginação
*/
export const setDataOnGrid = (dataLoad, setEntity, currentPage, itemsPerPage) => {

    if (!dataLoad) return;

    let limit = currentPage * itemsPerPage    
    let init = limit - itemsPerPage
    limit = limit < dataLoad.length ? limit : dataLoad.length
    
    setEntity(dataLoad.slice(init, limit))

}

/**
 *  Essa função aplica um critério de busca nos campos que compõem a entidade objeto da página
 *  Use a separação . (ponto) para especificar campos que estão dentro de objetos aninhados
 *  Passe os states e setStates da sua página aqui para que o método configure o grid de resultados
 *  A função usa tanto a entidade quanto seu backup para decidir o que mostrar tanto
 *  nas situações em que a busca encontrou algo, como quando não encontra
 *   
 * @param {*} value     Valor que se quer buscar nos campos do objeto
 * @param {*} fields    Campos de busca do objeto que aparecem no Grid
 * @param {*} setEntity     SetState para atualizar o que se vê no Grid após a busca
 * @param {*} entityBackup  Backup do conteúdo original carregado no Grid ao abrir a página
 * @param {*} setFoundRegisters  SetState para conter os registros encontrados pela busca
 * @param {*} currentPage   Indicador de qual página está sendo vista pelo usuário
 * @param {*} itemsPerPage  Quantos registros devem ser mostrados por página
 */
export const applySearch = (value, fields, setEntity, entityBackup, setFoundRegisters, currentPage, itemsPerPage, allowOptionalFields) => {
    
    let filtered = entityBackup?.filter((item) => {
        if (value === '') {
            return false;
        } else {
            let lowerCase = value.toLowerCase();

            let result = false
            fields.map((field) => {
                let fieldsCandidate = field.split(".")
                let target = ""
                if (fieldsCandidate.length > 1) {
                    if (fieldsCandidate[0] in item && fieldsCandidate[1] in item[fieldsCandidate[0]])
                        target = item[fieldsCandidate[0]][fieldsCandidate[1]].toLowerCase()
                    else {
                        if (!allowOptionalFields) {

                            throw new Error(`The field ${field} is not defined!`)
                        }
                    }
                } else {
                    if (fieldsCandidate[0] in item)
                        target = item[fieldsCandidate[0]].toString().toLowerCase()
                    else { 
                        if (!allowOptionalFields) {
                            throw new Error(`The field ${field} is not defined!`)
                        }
                    }
                }
                
                result = result || target.includes(lowerCase)
            })

            return result
        }
    })
    
    if (value === '') {
        setFoundRegisters(entityBackup?.length)
        setDataOnGrid(entityBackup, setEntity, currentPage, itemsPerPage)
    } else {             
        setFoundRegisters(filtered?.length)
        setDataOnGrid(filtered, setEntity, currentPage, itemsPerPage)
    }
}

/**
    Função que formata uma string para ficar com a primeira letra
    maiúscula
*/
export const titleCase = (str) => {
    return str.replace("_", " ").toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
}

/**
 * Takes an obj (the JSON object) and a value to search for as arguments.
 * Uses a for...in loop to iterate over the keys of the obj.
 * 
 * @param {*} obj 
 * @param {*} value 
 * @returns 
 */
export const getKeyByValue = (obj, value) => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === value) {
            return key;
        }
    }
    return undefined; // Value not found
}

/**
    Esta função valida os campos de uma entidade e mostra mensagens
    de alerta caso estejam vazias ou inválidas. 
    As validações são realizadas de acordo com o conjunto de 
    expresões regulares passadas em 'validations'.
    Apenas os campos listados em 'validations' são checados,
    tornando-se obrigatórios.
*/
export const validateData = (validations, entity, setModalTitle, setModalMessage, setShowModal) => {
    let result = true

    Object.keys(validations).map((key, index) => {

        //trantado chaves compostas padrão objeto_filho
        let keys = key.split("_")
        let value = ''
        if (keys.length == 1)
            value = entity[key]
        else if (keys.length == 2 && entity[keys[0]])
            value = entity[keys[0]][keys[1]]

        //detectando alias para os nomes dos campos de validação para 
        //deixar as mensagens de erro mais amigáveis
        let targetName = typeof validations[key] == "object" ? validations[key]?.alias : key
        let pattern = typeof validations[key] == "object" ? validations[key]?.pattern : validations[key]

        //valor vazio, arrays vazios, excetos objetos (que são ignorados na validação)
        if (!value || (Array.isArray(value) && value.length == 0) || (value && (!['object', 'number'].includes(typeof value)) && !value.trim())) {
            setModalTitle("Warning")
            setModalMessage('The field \'' + titleCase(targetName) + '\' is required!')
            setShowModal(true)
            result = false

        } else {
            //testando padrões de expressões regulares de validação
            if (pattern && !pattern.test(value)) {
                setModalTitle("Warning")
                setModalMessage('Invalid ' + titleCase(targetName))
                setShowModal(true)
                result = false
            }
        }

    })

    return result
}